<template>
  <!-- 비밀번호 변경 다이올로그 창 -->
  <div>
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card v-if="bChangeNow" flat tile>
        <v-card-title class="headline font-weight-bold">
          <div>비밀번호 변경 하신 지 3개월이 지났습니다.</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="6">
              <v-card flat tile align="center">
                <v-btn @click="SetChangePwd()" text>다음에 변경하기<v-icon class="mr-1">close</v-icon></v-btn>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card flat tile align="center">
                <v-btn @click="bChangeNow = !bChangeNow;bAuthModeP = bAuthModeE = false;" class="ml-2" dark>지금 변경하기<v-icon class="mr-1">mdi-chevron-right</v-icon></v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card v-else flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="blue--text text--darken-2 font-weight-bold">
            <v-icon class="mr-2" color="primary">how_to_reg</v-icon>비밀번호 변경
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="bChangeNow = true" width="90px" text class="ml-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
        </v-toolbar>
        <v-divider class="ml-2 mr-2"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 mt-4">
          <v-row class="mb-2">
            <v-col cols="12" class="pb-0">
              <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold d-flex align-center mb-4">
                <div style="width:100px;">인증 방식 선택</div>
                <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold">
                  휴대전화 본인인증 절차 진행 중 중단 된 경우, 닫기 버튼을 클릭 하여 재시도 바랍니다.
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" align="center">
              <div class="AuthBtn d-flex align-center justify-center flex-column" @click="AuthByPhone()">
                <v-icon style="font-size:100px;" class="mb-2">mdi-cellphone</v-icon>
                휴대전화
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" align="center">
              <div class="AuthBtn d-flex align-center justify-center flex-column" @click="AuthByEmail()">
                <v-icon style="font-size:100px;" class="mb-2">mdi-email-outline</v-icon>
                이메일
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bAuthDialog" max-width="600px">
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="blue--text text--darken-2 font-weight-bold">
            <v-icon class="mr-2" color="primary">how_to_reg</v-icon>이메일 정보 입력
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="bAuthDialog = false" width="90px" text class="ml-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
        </v-toolbar>
        <v-divider class="ml-4 mr-4 mb-6"></v-divider>
        <v-card-text v-if="!bAuthFinished">
          <v-row>
            <v-col cols="6">
              <v-text-field @click:append-outer="PwdCertifyEmail()"  @keyup="ResetCertify()" @keyup.enter="PwdCertifyEmail()" v-model="editedItem.cEmail" :loading="bAuthSendLoading" append-outer-icon="send" dense class="mb-n2" ref="cEmailRef" persistent-placeholder>
                <template v-slot:label>
                  메일주소<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="cCode" :disabled="!bAuthIng" @keyup.enter="CheckAuthNumEmail()" dense class="mb-n2" hint="[ 6자리 숫자 ]" ref="cCodeRef" persistent-placeholder>
                <template v-slot:label>
                  인증번호<strong v-if="bAuthIng" class="red--text">*</strong>
                </template>
                <template v-slot:append>
                  <div v-if="bAuthIng" class="d-flex">
                    <v-icon @click="CheckAuthNumEmail()" class="mr-2">mdi-check</v-icon>
                    <div style="width:40px" class="pt-1">{{cCertifyTime}}</div>
                  </div>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text v-else class="pr-4 pl-4 pb-6 mt-4">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold">
                비밀번호 변경
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cPwd" @keyup="filteringHandlerPwd" :class="{'test_password_style' : !show1}" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.cPwd)" @click:append="show1 = !show1" ref="cPwdRef" placeholder="새로운 비밀번호를 입력하세요." dense persistent-placeholder>
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">새 비밀번호<strong class="red--text">*</strong></div>
                </template>
                <template v-slot:append>
                  <div style="-webkit-text-security: none;">
                    <v-icon @click="show1 = !show1">{{cIconText_1}}</v-icon>
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cPwd1" @keyup="filteringHandlerPwd1" :class="{'test_password_style' : !show2}" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.cPwd1)" @click:append="show2 = !show2" @keyup.enter="SetChangePwd()" ref="cPwd1Ref" placeholder="다시 한번 입력하세요." dense persistent-placeholder>
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">비밀번호 확인<strong class="red--text">*</strong></div>
                </template>
                <template v-slot:append>
                  <div style="-webkit-text-security: none;">
                    <v-icon @click="show2 = !show2">{{cIconText_2}}</v-icon>
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="ma-2 mt-0"></v-divider>
              <v-btn @click="SetChangePwd()" class="ml-2" dark><v-icon class="mr-1">mdi-pencil</v-icon>변경</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import Util from "../Util.js";

export default {
  components: {
  },
  data: () => ({
    OpenWindow : null,
    dialog : false,
    bAuthSendLoading : false,
    bAuthIng : false,
    bChangeNow : false,
    bAuthModeP : false,
    bAuthModeE : false,
    bAuthDialog : false,
    bAuthFinished : false,
    show1 : false,
    show2 : false,
    cCode: "",
    interval : {},
    cCircularTime : 0,
    cCertifyTime : "",
    oCheckEmail : {
      bResult : false,
      cEmail : "",
    },
    editedItem:{
      cCustomId : "",
      cCustomNickId : "",
      cOriginPwd : "",
      cBirth : "",
      cEmail : "",
      cTel : "",
      cPwd : "",
      cPwd1 : "",
      cTestDate : "",
    },
    defaultItem:{
      cCustomId : "",
      cCustomNickId : "",
      cOriginPwd : "",
      cBirth : "",
      cEmail : "",
      cTel : "",
      cPwd : "",
      cPwd1 : "",
      cTestDate : "",
    },
  }),
  computed: {
    cIconText_1() {
      return this.show1 ? "mdi-eye": "mdi-eye-off"
    },

    cIconText_2() {
      return this.show2 ? "mdi-eye": "mdi-eye-off"
    }
  },

  watch: {
    bAuthDialog (val) {
      if (!val) {
        this.ResetAuthEmail();
      }
    },
  },

  created() {
  },

  mounted() {
    window.addEventListener("message", this.onSendMessage);
  },

  beforeDestroy() {
    clearInterval(this.interval)
    window.removeEventListener("message", this.onSendMessage);
  },


  methods : {
    CopyByCtrlC(event,value) {
      if (event.key.toUpperCase() == "C") {
        navigator.clipboard.writeText(value)
      }
    },

    filteringHandlerPwd(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.cPwdRef.lazyValue = ResultWord
    },
    
    filteringHandlerPwd1(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.cPwd1Ref.lazyValue = ResultWord
    },

    ShowDialog(CustomInfo, OriginPwd, TestDate) {
      this.editedItem.cCustomId = CustomInfo.CustomId
      this.editedItem.cCustomNickId = CustomInfo.CustomNickId
      this.editedItem.cOriginPwd = OriginPwd
      this.editedItem.cBirth = CustomInfo.Birth
      this.editedItem.cTestDate = TestDate
      this.dialog = true;
      this.bChangeNow = true;

      this.ResetCertify();
    },

    AuthByPhone() {
      if (this.bAuthModeP) {
        EventBus.$emit("onShowMsgBox","휴대폰 인증이 진행 중 입니다.","기존에 진행중인 인증을 먼저 마무리 하여 주세요.")
        return
      }

      this.bAuthModeE = false;
      this.bAuthModeP = true;
      if (this.OpenWindow != null) {
        this.OpenWindow.close();
      }

      this.OpenWindow = window.open(process.env.VUE_APP_URL_KCB_API  + "phone_popup2.asp", "auth_popup", "width=430, height=600, scrollbars=yes, location=no");
    },

    onSendMessage(event) {
      this.bAuthModeP = false;
      if (event.data.RSLT_CD == "B000") {
        this.bAuthDialog = true;
        this.bAuthFinished = true
        this.editedItem.cTel = event.data.TEL_NO;
        // this.$emit('ClosePledge',event.data)
      } else {
        return
      }
    },

    AuthByEmail() {
      if (this.bAuthModeP) {
        EventBus.$emit("onShowMsgBox","휴대폰 인증이 진행 중 입니다.","기존에 진행중인 인증을 먼저 마무리 하여 주세요.")
        return
      }
      
      this.bAuthDialog = true;
      this.bAuthModeE = true;
    },

    ResetCertify(){
      clearInterval(this.interval)
      this.bAuthIng = false;
      this.bAuthSendLoading = false;
      this.cCircularTime = 0
      this.cCode = ""
      this.cCertifyTime = ""
    },
    
    ResetAuthEmail(){
      this.editedItem.cEmail = ""
      this.oCheckEmail.bResult = false
      this.editedItem.cPwd = ""
      this.editedItem.cPwd1 = ""
      this.bAuthFinished = false
      this.bAuthModeE = false
      this.show1 = false
      this.show2 = false
      this.oCheckEmail.cEmail = ""
      this.ResetCertify();
    },

    CountTime() {
      this.cCircularTime = 180
      this.cCertifyTime = "3:00"
      this.interval = setInterval(() => {
        this.cCircularTime -= 1
        this.cCertifyTime = Util.ChangeNumToMin(this.cCircularTime)
        if (this.cCircularTime == 0) {
          this.ResetCertify()
        }
      }, 1000)
    },

    PwdCertifyEmail() {
      this.ResetCertify();
      if (this.editedItem.cEmail == "" ) {
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "인증번호를 받을 이메일의 전화번호를 입력하여 주세요.");
        return;
      }

      this.oCheckEmail = Util.CheckEmail(this.editedItem.cEmail)
      if (!this.oCheckEmail.bResult) {
        EventBus.$emit("onShowMsgBox", "이메일 주소가 정확하지 않습니다.","입력하신 이메일을 확인하여 주세요.");
        return;
      }
      this.editedItem.cEmail = this.oCheckEmail.cEmail

      this.bAuthSendLoading = true;
      var posData = {
        CustomId: this.editedItem.cCustomId,
        cEmail: this.editedItem.cEmail,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "PwdCertifyEmail", posData, {
          headers: {
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.bAuthSendLoading = false;
            this.bAuthIng = true;
            this.CountTime();
            this.$refs.cCodeRef.focus();
            EventBus.$emit("onShowMsg",false, "인증번호가 이메일로 전송되었습니다.");
          } else if (res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox","이메일을 잘못 입력하셨습니다.",res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.bAuthSendLoading = false;
        })
        .catch(err => {
          this.bAuthSendLoading = false;
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    CheckAuthNumEmail(){
      var posData = {
        Email : this.editedItem.cEmail,
        Code : this.cCode,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "CheckAuthNumEmail", posData, {
          headers: {}
        })
        .then(res => {
          if (res.data.ResultCd == "00") {
            this.ResetCertify();
            this.bAuthFinished = true;
            EventBus.$emit("onShowMsg",false, "인증이 완료 되었습니다.");
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","인증번호가 일치하지 않습니다.","입력하신 인증번호를 확인 하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    CheckPW(cPwd,cCustomNickId,cBirth) {
      if(!Util.CheckPWFormNew(cPwd)){
        EventBus.$emit("onShowMsgBox","비밀번호 형식이 잘못 되었습니다.", "비밀번호는 영문+숫자(10자리 ~ 30자리) 또는 영문+특수기호(10자리 ~ 30자리) 또는 영문+숫자+특수기호(8자리 ~ 30자리)로 설정해주세요.");
        return false;
      }

      if(/(\w)\1\1/.test(cPwd)){
        EventBus.$emit("onShowMsgBox","비밀번호 형식이 잘못 되었습니다.", "비밀번호는 같은 문자를 3번 이상 사용하실 수 없습니다.");
        return false;
      }

      if(cPwd.search(cCustomNickId)>-1){
        EventBus.$emit("onShowMsgBox","비밀번호 형식이 잘못 되었습니다.", "비밀번호에 아이디가 포함되었습니다.");
        return false;
      }

      if(cPwd.search(cBirth)>-1){
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호에 생년월일이 포함되었습니다.");
        return false;
      }

      return true;
    },

    SetChangePwd() {
      var ChangePwd = ""

      if (!this.bChangeNow) {
        let TestBirth = this.editedItem.cBirth.substring(5,7) + this.editedItem.cBirth.substring(8,10)

        if (this.editedItem.cPwd == "") {
          EventBus.$emit("onShowMsgBox", "신규 비밀번호가 입력되지 않았습니다.","신규 비밀번호를 입력하여 주세요.");
          return
        }

        if (!this.CheckPW(this.editedItem.cPwd,this.editedItem.cCustomNickId,TestBirth)) {
          return;
        }

        if (this.editedItem.cPwd1 == "") {
          EventBus.$emit("onShowMsgBox", "비밀번호 확인이 입력되지 않았습니다.","신규 비밀번호와 동일하게 입력하여 주세요.");
          return
        }
        
        if (!this.CheckPW(this.editedItem.cPwd1,this.editedItem.cCustomNickId,TestBirth)) {
          return;
        }

        if (this.editedItem.cPwd != this.editedItem.cPwd1){
          EventBus.$emit("onShowMsgBox", "비밀번호가 일치하지 않습니다.","신규 비밀번호와 확인 칸을 확인하여 주세요.");
          return
        }

        ChangePwd = this.editedItem.cPwd
      } else {
        ChangePwd = this.editedItem.cOriginPwd
      }

      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        cCustomId: this.editedItem.cCustomId,
        cCustomNickId: this.editedItem.cCustomNickId,
        cPwd : this.$store.state.cAES256Encrypt(ChangePwd),
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetChangePwd", posData, {
          headers: {}
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.dialog = false;
            this.bAuthDialog = false;
            
            this.$emit("GoLogin", this.editedItem.cTestDate, ChangePwd)
            if (!this.bChangeNow) {
              EventBus.$emit("onShowMsg",false, "비밀번호 수정이 완료되었습니다.");
            }
          } else if (res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox","삭제된 회원입니다.",res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>
<style scoped>
  .test_password_style { 
    -webkit-text-security:disc; 
  }

  
  .AuthBtn {
    color : black;
    cursor : pointer;
    width : 120px;
    height : 150px;
  }

  .AuthBtn:hover {
    opacity: 1;
    /* font-weight: 900 !important; */
    background: #FFFFFF22;
    border-radius: 20px;
    box-shadow: 0px 0px 20px #00000022;
  }
</style>